import { createGlobalStyle, css } from 'styled-components';

import { ScrollBarStyle } from 'environment';

import { StyleGuide } from './StyleGuide';
import { isOnWindows } from 'helpers/generic';

export const GlobalStyle = createGlobalStyle`
	* {
		box-sizing: border-box;
		/* Without this option we can't set backgrounds on divs on print mode */
		-webkit-print-color-adjust: exact !important;
	}

	html {
		width: 100vw;
		overflow-x: hidden;
	}

	html, body {
		height: 100%;

		${
			isOnWindows() &&
			css`
				overflow: auto;

				${ScrollBarStyle}

				div {
					${ScrollBarStyle}
				}
			`
		};
	}

	html.is-touch {
		.showOnTouchDevices {
			visibility: visible;
		}
	}

	div#root {
		min-height: 100%;
	}

	html {
		/* SET rem BASE TO 10px */
		font-size: 10px;
		padding-right: env(safe-area-inset-right);
	}

	html * {
		font-family: 'Roboto Flex', sans-serif;
	}

	body {
		margin: 0;
		padding: 0;
		overflow: scroll;
		overflow-x: hidden;
		overflow-y: overlay;
		background-color: #ffffff;
	}

	/* CSS resetters */
	h1, h2, h3, h4, h5, h6, p, label {
		margin: 0;
	}

	table {
		border-spacing: 0;
	}

	${StyleGuide}

	.pulse-vibrant-green {
		animation: pulse-vibrant-green 1s ease-out;
	}

	@keyframes pulse-vibrant-green {
		15%, 90% {
			background-color: rgba(38, 208, 124, 0.3); /* #vibrant green, 30% */
		}
	}
`;
